import { Contract } from "../types";
import { DownloadContract } from "./DownloadContract.tsx";
import { UploadContract } from "./UploadContract.tsx";

export const downloadContractBody = (rowData: Contract) => (
  <>
    <UploadContract contractData={rowData} />
    <DownloadContract contractData={rowData} />
  </>
);
